import React from "react";
import { useNavigate } from "react-router-dom";

export default function ClinicDashboard() {
  const navigate = useNavigate();

  const handleInviteClick = () => {
    navigate("/invite-staff");
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Welcome, Clinic Admin</h2>
      <p>Use the tools below to manage your clinic.</p>

      <button
        onClick={handleInviteClick}
        style={{
          marginTop: "2rem",
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          backgroundColor: "#004aad",
          color: "white",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        + Invite a Staff Member
      </button>
    </div>
  );
}
